import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-screen h-screen z-40 flex justify-center items-center bottom-0 left-0 fixed bg-gray-400 bg-opacity-80 overflow-auto"
}
const _hoisted_2 = { class: "p-4 w-10/12 lg:w-75 md:w-10/12 max-w-lg h-10/12 bg-white rounded-md md:p-10 flex flex-col grid grid-cols-1 mt-10 md:mt-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "cursor-pointer font-bold hover:text-sirit_blue-400" }, "x", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-medium mb-3 text-center" }, "Comunicar cobro", -1)
const _hoisted_6 = { class: "w-10/12 flex flex-col items-center mx-auto md:px-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "md:mb-3 text-md" }, "Si has recibido algún cobro parcial o completo de tu deudor, infórmanos para que podamos gestionar correctamente tu reclamación.", -1)
const _hoisted_8 = { class: "text-md mb-2 sm:mb-3 md:mb-4 xl:mb-8" }
const _hoisted_9 = { class: "w-full grid grid-cols-1 sm:grid-cols-4 gap-2 text-left" }
const _hoisted_10 = { class: "flex flex-col col-span-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-md md:pt-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sirit_blue-600 font-bold" }, "*"),
  /*#__PURE__*/_createTextVNode("Fecha ingreso")
], -1)
const _hoisted_12 = { class: "flex flex-col col-span-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-md md:pt-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sirit_blue-600 font-bold" }, "*"),
  /*#__PURE__*/_createTextVNode("Importe")
], -1)
const _hoisted_14 = { class: "w-full flex" }
const _hoisted_15 = { class: "w-1/12 flex items-center justify-center h-5 py-5 mt-2" }
const _hoisted_16 = {
  key: 0,
  class: "text-sirit_blue-500 text-md"
}
const _hoisted_17 = { class: "flex flex-col col-span-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-md md:pt-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sirit_blue-600 font-bold" }, "*"),
  /*#__PURE__*/_createTextVNode("Concepto")
], -1)
const _hoisted_19 = { class: "flex flex-col items-end col-span-4 md:pt-3" }
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_alert = _resolveComponent("alert")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_fa = _resolveComponent("fa")!

  return ($props.openModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_loading, { loading: _ctx.loading }, null, 8, ["loading"]),
        _createVNode(_component_alert, {
          onOnFire: $setup.eventCloseAlert,
          data_alert: _ctx.data_alert
        }, null, 8, ["onOnFire", "data_alert"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: "text-right",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeModal()))
            }, _hoisted_4),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, "Importe por reclamar: " + _toDisplayString($props.amount) + " €", 1)
            ])
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_Datepicker, {
                  onInternalModelChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.setFactDate())),
                  autoApply: true,
                  modelValue: _ctx.factDate,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.factDate) = $event)),
                  locale: "es",
                  class: "w-full h-full mt-1 md:mt-2 border-black rounded-md border-2",
                  format: "dd/MM/yyyy"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    id: "input-company",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataTransfer.amount) = $event)),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.setFormatAmount())),
                    type: "text",
                    autocomplete: "off",
                    placeholder: "",
                    class: "boder border-black w-full h-5 py-5 mt-1 md:mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-rose-500 rounded-md border-2 px-3",
                    required: ""
                  }, null, 544), [
                    [_vModelText, _ctx.dataTransfer.amount]
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_fa, { icon: "euro-sign" })
                  ])
                ]),
                ($setup.form_.errorAmount)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "El importe no puede ser superior a la deuda"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  id: "input-company",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataTransfer.concept) = $event)),
                  type: "text",
                  autocomplete: "off",
                  placeholder: "",
                  class: "boder border-black w-full h-5 py-5 mt-1 md:mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-rose-500 rounded-md border-2 px-3",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.dataTransfer.concept]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  type: "submit",
                  disabled: $setup.form_.errorAmount,
                  class: _normalizeClass([[$setup.form_.errorAmount ? 'bg-gray-300' : 'bg-sirit_blue-500 hover:bg-sirit_blue-600'], "w-full mt-2 md:mt-4 py-2 md:px-6 text-white rounded-md border-2 font-bold"])
                }, "Notificar", 10, _hoisted_20)
              ])
            ])
          ], 32)
        ])
      ]))
    : _createCommentVNode("", true)
}